import { QueryClient } from "@tanstack/react-query";

/**
 * React Query 的全域設定。
 *
 * 401 不重試 —— api-client 已經處理過 token 換發並重試一次，
 * 到這裡還是 401 就代表 session 真的結束了，重試只是拖延導向登入頁。
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        const status = (error as { status?: number } | null)?.status;
        if (status === 401 || status === 403 || status === 404) return false;
        return failureCount < 2;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
});
